import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import { AppContext, useWithAuth } from '../../containers/App'
import styled, { css } from 'styled-components'
import Layout from '../../components/Layout'
import Button from '../../components/Button'
// @ts-ignore @todo add apprioprate declaration file
import downloadIcon from '../../images/downloadIcon.svg'
import colors from '../../styles/colors'
import ReactSelect from 'react-select'
import { voivodeships } from '../../components/Units/utils'
import {
  selectStyles,
  UnitsListProps,
  StatisticsProps,
  StatisticsFiltersProps,
} from './utils'
import ReactDatePicker from 'react-datepicker'
import moment from 'moment'
import withLoading from '../../utils/withLoading'
import { useNotifications } from '../Notifications'
import withPermissions from '../../containers/withPermissions'
import { CitiesProps } from './utils'
import { User } from '../../components/Units/utils'
import ReportGenerateModal from './Modal'

const DATE_FORMAT = 'YYYY-MM-DD'

const decorate = withPermissions

const Statistics = () => {
  const user = useContext<User>(AppContext)
  const citiesEndpoint = '/diagnostic/rest/unit/cities/list'
  const unitsOptionsEndpoint = '/diagnostic/rest/unit/list'
  const statisticsEndpoint = '/diagnostic/rest/statistics/usage'
  const unitsEndpoint = `/diagnostic/rest/unit/${user.unitId}`
  const GENERATE_REPORT_ENDPOINT = '/report/rest/report'

  const withAuth = useWithAuth()
  const { notify } = useNotifications()
  const LoadingStatistics = withLoading(DataWrapper)
  const [ready, setReady] = useState<boolean>(false)
  const [modalReady, setModalReady] = useState<boolean>(false)
  const today = new Date()
  const normalizeToday = moment(today).format(DATE_FORMAT)

  const [statistics, setStatistics] = useState<StatisticsProps>({
    units: {
      count: 0,
      publicCount: 0,
      privateCount: 0,
    },
    diagnosticians: {
      count: 0,
      activeCount: 0,
      inactiveCount: 0,
    },
    patients: {
      count: 0,
      publicCount: 0,
      privateCount: 0,
    },
    examinations: {
      count: 0,
      activeCount: 0,
      inactiveCount: 0,
    },
  })

  const [statisticsFilters, setStatisticsFilters] = useState<
    StatisticsFiltersProps
  >({
    voivodeship: null,
    city: null,
    unitId: null,
    from: '2022-06-01',
    to: normalizeToday,
    name: null,
  })

  const [cities, setCities] = useState<CitiesProps>({
    data: [],
    search: '',
  })

  const NormalizeCities = cities.data.map((city) => {
    return { value: city, label: city }
  })

  const [unitsList, setUnitsList] = useState<UnitsListProps>({
    data: [
      {
        id: 0,
        name: '',
      },
    ],
    search: '',
  })

  const NormalizeUnits = unitsList.data.map((unit) => {
    return { value: unit.id, label: unit.name }
  })

  const handleChangeDateFrom = (dateFrom) => {
    setStatisticsFilters({
      ...statisticsFilters,
      from: moment(dateFrom).format(DATE_FORMAT),
    })
  }

  const handleChangeDateTo = (dateTo) => {
    setStatisticsFilters({
      ...statisticsFilters,
      to: moment(dateTo).format(DATE_FORMAT),
    })
  }

  const handleChangeCities = (city) => {
    setStatisticsFilters({
      ...statisticsFilters,
      city: city.value,
    })
  }

  const handleChangeUnits = (unit) => {
    setStatisticsFilters({
      ...statisticsFilters,
      unitId: unit.value,
    })
  }

  const handleChangeVoivodeship = (voivodeship) => {
    setStatisticsFilters({
      ...statisticsFilters,
      voivodeship: voivodeship.value,
    })
  }

  const fetchUnit = async () => {
    const result = await withAuth(`${unitsEndpoint}`, {
      method: 'GET',
    })
    return result
  }

  const fetchUnitData = async () => {
    try {
      const result = await fetchUnit()
      setStatisticsFilters({
        ...statisticsFilters,
        name: result.name,
        unitId: result.id,
        voivodeship: result.voivodeship,
        city: result.city,
      })
    } catch {
      notify('Nie udało się pobrać jednostek', 'error')
    }
  }

  useEffect(() => {
    if (user.userLevel !== 9 && user.userId !== null) {
      fetchUnitData()
    }
  }, [
    statisticsFilters.city,
    statisticsFilters.name,
    statisticsFilters.unitId,
    statisticsFilters.voivodeship,
  ])

  const fetchStatistics = async () => {
    setReady(false)
    const result = await withAuth(`${statisticsEndpoint}`, {
      method: 'POST',
      payload: {
        voivodeship:
          statisticsFilters.voivodeship !== ''
            ? statisticsFilters.voivodeship
            : undefined,
        city:
          statisticsFilters.city !== '' ? statisticsFilters.city : undefined,
        unitId:
          statisticsFilters.unitId === null
            ? user.unitId
            : statisticsFilters.unitId,
        from: statisticsFilters.from,
        to: statisticsFilters.to,
      },
    })
    setReady(true)
    return result
  }

  const fetchStatisticsData = async () => {
    try {
      const result = await fetchStatistics()
      setStatistics({
        units: {
          ...result.units,
        },
        diagnosticians: {
          ...result.diagnosticians,
        },
        patients: {
          ...result.patients,
        },
        examinations: {
          ...result.examinations,
        },
      })
    } catch {
      notify('Nie udało się pobrać statystyków', 'error')
    }
  }

  useEffect(() => {
    fetchStatisticsData()
  }, [
    statisticsFilters.city,
    statisticsFilters.from,
    statisticsFilters.to,
    statisticsFilters.unitId,
    statisticsFilters.voivodeship,
  ])

  const fetchCities = async () => {
    const result = await withAuth(`${citiesEndpoint}`, {
      method: 'POST',
      payload: {
        search: cities.search,
      },
    })
    return result
  }

  const fetchCitiesData = async () => {
    try {
      const result = await fetchCities()
      setCities({ data: result.cities, search: cities.search })
    } catch {
      notify('Nie udało się pobrać miast', 'error')
    }
  }

  useEffect(() => {
    if (user.userLevel === 9) {
      fetchCitiesData()
    }
  }, [cities.search])

  const fetchUnitsOptions = async () => {
    const result = await withAuth(`${unitsOptionsEndpoint}`, {
      method: 'POST',
      payload: {
        search: unitsList.search,
      },
    })
    return result
  }

  const fetchUnitsDataOptions = async () => {
    try {
      const result = await fetchUnitsOptions()
      setUnitsList({ data: result.units, search: unitsList.search })
    } catch {
      notify('Nie udało się pobrać jednostek', 'error')
    }
  }

  useEffect(() => {
    if (user.userLevel === 9) {
      fetchUnitsDataOptions()
    }
  }, [unitsList.search])

  const generateReport = async () => {
    try {
      const response = await withAuth(GENERATE_REPORT_ENDPOINT, {
        method: 'POST',
        payload: {
          type: 'STATISTICS',
          voivodeship: statisticsFilters.voivodeship,
          city: statisticsFilters.city,
          unitId: statisticsFilters.unitId,
          dateFrom: statisticsFilters.from,
          dateTo: statisticsFilters.to,
        },
      })
      if (response.success) {
        setModalReady(true)
      }
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <Layout>
      <Helmet htmlAttributes={{ lang: 'pl-PL' }}>
        <title>Statystyki</title>
      </Helmet>
      <HeadingWrapper>
        <StyledH1>Statystyki</StyledH1>
        <FieldContainer>
          <FieldWrapper>
            <StyledLabel htmlFor="voivodeship">Województwo</StyledLabel>
            <ReactSelect
              inputId="voivodeship"
              styles={selectStyles}
              options={voivodeships}
              placeholder={
                user.userLevel === 9
                  ? `Wszystkie`
                  : voivodeships.find(
                      (value) => value.value === statisticsFilters.voivodeship
                    )?.label
              }
              noOptionsMessage={() => 'Brak danych'}
              isDisabled={user.userLevel === 9 ? false : true}
              onChange={handleChangeVoivodeship}
            />
          </FieldWrapper>
          <FieldWrapper>
            <StyledLabel htmlFor="city">Miasto</StyledLabel>
            <ReactSelect
              inputId="city"
              styles={selectStyles}
              options={NormalizeCities}
              placeholder={
                user.userLevel === 9 ? `Wszystkie` : statisticsFilters.city
              }
              noOptionsMessage={() => 'Brak danych'}
              isDisabled={user.userLevel === 9 ? false : true}
              onChange={handleChangeCities}
            />
          </FieldWrapper>
          <FieldWrapper>
            <StyledLabel htmlFor="unit">Jednostka</StyledLabel>
            <ReactSelect
              inputId="unit"
              styles={selectStyles}
              options={NormalizeUnits}
              placeholder={
                user.userLevel === 9 ? `Wszystkie` : statisticsFilters.name
              }
              noOptionsMessage={() => 'Brak danych'}
              isDisabled={user.userLevel === 9 ? false : true}
              onChange={handleChangeUnits}
            />
          </FieldWrapper>
          <FieldWrapper>
            <StyledLabel htmlFor="date-from">Data od</StyledLabel>
            <StyledReactDatepicker
              id="date-from"
              placeholderText={DATE_FORMAT}
              showYearDropdown={true}
              showMonthDropdown={true}
              selected={moment(statisticsFilters.from)}
              onChange={handleChangeDateFrom}
              name="startDate"
              dateFormat={DATE_FORMAT}
            />
          </FieldWrapper>
          <FieldWrapper>
            <StyledLabel htmlFor="date-to">Data do</StyledLabel>
            <StyledReactDatepicker
              id="date-to"
              placeholderText={DATE_FORMAT}
              showYearDropdown={true}
              showMonthDropdown={true}
              selected={moment(statisticsFilters.to)}
              minDate={moment(statisticsFilters.from)}
              onChange={handleChangeDateTo}
              name="endDate"
              dateFormat={DATE_FORMAT}
              popperModifiers={{
                preventOverflow: {
                  enabled: true,
                }
              }}
              popperProps={{
                positionFixed: true
              }}
            />
          </FieldWrapper>
          {user.userLevel === 9 && (
            <StyledBtn
              link=""
              icon={downloadIcon}
              color="white"
              label="Eksport do CSV"
              onClick={() => generateReport()}
              altTag=""
              srText=""
            />
          )}
        </FieldContainer>
      </HeadingWrapper>
      {user.userLevel === 3 ? (
        <LoadingStatistics ready={ready}>
          <HeadingP>{statisticsFilters.name}</HeadingP>
          <StyledH2>
            Liczba diagnostów: {statistics.diagnosticians.count}
          </StyledH2>
          <StyledP>
            Konta nieaktywne - {statistics.diagnosticians.inactiveCount}{' '}
            diagnostów
          </StyledP>
          <StyledP>
            Konta aktywne - {statistics.diagnosticians.activeCount} diagnostów
          </StyledP>
          <StyledH2>
            Liczba zarejestrowanych dzieci: {statistics.patients.count}
          </StyledH2>
          <StyledH2>
            Liczba zarejestrowanych diagnoz: {statistics.examinations.count}
          </StyledH2>
          <StyledP>
            Zakończone - {statistics.examinations.inactiveCount} diagnoz
          </StyledP>
        </LoadingStatistics>
      ) : (
        <LoadingStatistics ready={ready}>
          <StyledH2>Liczba poradni: {statistics.units.count}</StyledH2>
          <StyledP>
            Poradnie publiczne - {statistics.units.publicCount} placówek
          </StyledP>
          <StyledP>
            Poradnie niepubliczne - {statistics.units.privateCount} placówek
          </StyledP>
          <StyledH2>
            Liczba diagnostów: {statistics.diagnosticians.count}
          </StyledH2>
          <StyledP>
            Konta nieaktywne - {statistics.diagnosticians.inactiveCount}{' '}
            diagnostów
          </StyledP>
          <StyledP>
            Konta aktywne - {statistics.diagnosticians.activeCount} diagnostów
          </StyledP>
          <StyledH2>
            Liczba zarejestrowanych dzieci: {statistics.patients.count}
          </StyledH2>
          <StyledP>
            W poradniach publicznych: {statistics.patients.publicCount}
          </StyledP>
          <StyledP>
            W poradniach niepublicznych: {statistics.patients.privateCount}
          </StyledP>
          <StyledH2>
            Liczba zarejestrowanych diagnoz: {statistics.examinations.count}
          </StyledH2>
          <StyledP>
            Diagnozy aktywne: {statistics.examinations.inactiveCount}{' '}
          </StyledP>
          <StyledP>
            Diagnozy nieaktywne: {statistics.examinations.activeCount}
          </StyledP>
        </LoadingStatistics>
      )}
      <ReportGenerateModal
        isOpen={modalReady}
        onClose={() => setModalReady(false)}
      />
    </Layout>
  )
}

export default decorate(Statistics)

const HeadingWrapper = styled.div`
  width: 100%;
  background-color: #eaeaea;
  padding: 20px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${colors.alabaster};
`
const FieldContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-left: 30px;
  @media (max-width: 1460px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  margin: 1em 0 1em 0;
`
const StyledH1 = styled.h1`
  margin: 0 20px 0 32px;
  font-weight: 200;
  font-size: 32px;
  color: ${colors.light_black};
`

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const StyledLabel = styled.label`
  text-transform: uppercase;
  font-family: 'Raleway';
  font-size: 12px;
  font-weight: 600;
`

const StyledBtn = styled(Button)`
  width: 180px;
  margin-top: 19px;
  @media (max-width: 1460px) {
    width: 220px;
  }
`
const StyledReactDatepicker = styled(ReactDatePicker)`
  ${(props) => props.width && css`width: ${props.width}px;`}
  border: 1px solid ${colors.gray};
  font-size: 14px;
  padding: 10px 15px;
  border-radius: 4px;
  height: 50px;
  box-sizing: border-box;
  font-size: 12px;
  display: flex;
  flex-grow: 1;
  align-items: center;
  height: 57px;
  border-radius: 4px;
  padding: 2px 10px 0;
  color: ${colors.light_black};
  width: 150px;
  margin-right: 15px;
  @media (max-width: 1460px) {
    width: 220px;
  }
`
const DataWrapper = styled.div`
  margin-top: 45px;
  margin-left: 32px;
`

const StyledH2 = styled.h2`
  font-family: 'Raleway';
  font-weight: 500;
  font-size: 25px;
`

const StyledP = styled.p`
  font-family: 'Raleway';
  font-weight: 500;
  font-size: 18px;
`

const HeadingP = styled.p`
  font-family: 'Raleway';
  font-weight: 400;
  font-size: 25px;
  width: 70%;
`
